import { useContext } from 'react';
import { CatalogContext } from '../contexts/complexContexts';

export const useCatalog = () => {
  const context = useContext(CatalogContext);
  if (!context) {
    throw new Error('useCatalog must be used within CatalogProvider');
  }
  return context;
};